__turbopack_context__.v({
  "empty": "WMenu-module__YIARca__empty",
  "item": "WMenu-module__YIARca__item",
  "link": "WMenu-module__YIARca__link",
  "linkActive": "WMenu-module__YIARca__linkActive",
  "linkInActivePath": "WMenu-module__YIARca__linkInActivePath",
  "list": "WMenu-module__YIARca__list",
  "menu": "WMenu-module__YIARca__menu",
});
